import { render } from "./InterventoDetail.vue?vue&type=template&id=ab517980&scoped=true"
import script from "./InterventoDetail.vue?vue&type=script&lang=ts"
export * from "./InterventoDetail.vue?vue&type=script&lang=ts"

import "./InterventoDetail.vue?vue&type=style&index=0&id=ab517980&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ab517980"

export default script